export const getInitialState = (): any => ({
  uploadData: {}
});
